var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 27.6c0-2.8 1.6-3.5 3.6-1.5l20.3 20.3c2 2 2 5.2 0 7.2L46.1 73.9c-2 2-3.6 1.3-3.6-1.5V27.6zM0 50c0 27.6 22.4 50 50 50s50-22.4 50-50S77.6 0 50 0 0 22.4 0 50"
  })));
};
export default SvgPlay;